module.exports = __webpack_public_path__ + "assets/66058b81bb2e8e69603e82d4754cb4f7.png";